<template>
    <b-tooltip :label="label" :always="show" position="is-top" size="is-large" multilined type="is-white">
        <span class="icon" @click="show = !show"><i class="fas fa-question-circle"></i></span>
    </b-tooltip>
</template>

<script>
    import BTooltip from "buefy/src/components/tooltip/Tooltip";
    export default {
        name: "HcpHelp",
        components: {BTooltip},
        data: () => ({
            show: false,
        }),
        computed: {
            label() {
                if(!this.$slots.default) {
                    return '';
                }
                return this.$slots.default[0].text;
            }
        },
    }
</script>

<style scoped>

</style>